import styled from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import {
  SkeletonButton as SkeletonButtonComponent,
  SkeletonHeadline as SkeletonHeadlineComponent,
} from '@xingternal/skeleton';
import { spaceL, spaceM, spaceS, spaceXXL } from '@xingternal/tokens';

import { JobTeaserListSkeleton } from '@/components/job-teaser/components/skeleton';

export const Header = styled.section`
  display: flex;
  margin-top: ${spaceL};

  @media ${mediaConfined} {
    margin-top: 48px;
    margin-bottom: ${spaceL};
  }
`;

export const SkeletonHeadline = styled(SkeletonHeadlineComponent)`
  align-self: flex-start;
  width: 50%;
  margin-bottom: ${spaceM};

  @media ${mediaConfined} {
    width: 30%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-self: flex-end;
  width: 20%;
  margin-left: auto;

  @media ${mediaConfined} {
    width: 40%;
  }
`;

export const SkeletonButton = styled(SkeletonButtonComponent)`
  margin-left: ${spaceS};

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const ResultItemSkeleton = styled(JobTeaserListSkeleton)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: 48px;
  }
`;
